<mat-form-field
  appearance="outline"
  [class]="customRegistrationDate"
  [ngClass]="{
    isRegistrationDate: isRegistrationDateDisbaled
  }"
>
  <mat-label>Registration Date</mat-label>
  <input
    matInput
    #registrationInput
    id-automation="registration_date_id"
    [matDatepicker]="registrationDate"
    formControlName="registration_date"
    appDateFormat
    [min]="minDate"
    [max]="maxDate"
    [readonly]="true"
    (click)="registrationDate.open()"
    (keyup.enter)="EnterKey($event)"
    [attr.data-disabled]="isRegistrationDateDisbaled ? 'true' : null"
  />
  <mat-datepicker-toggle
    matSuffix
    [for]="registrationDate"
    (keydown.enter)="!isRegistrationDateDisbaled && $event.preventDefault()"
    [attr.data-disabled]="isRegistrationDateDisbaled ? 'true' : null"
    ><mat-icon matDatepickerToggleIcon>
      <img
        src="assets/icon/calendar.svg"
        class="cursor-pointer mb-2"
        alt="calendar"
      />
    </mat-icon>
  </mat-datepicker-toggle>
  <mat-datepicker
    #registrationDate
    id-automation="datepicker_registration_date_id"
  ></mat-datepicker>
  <mat-error *ngIf="form.controls['registration_date']?.hasError('required')">
    This is a required field.
  </mat-error>
</mat-form-field>
